import * as Icons from "lucide-react";
import { Link } from "react-router-dom";

export function CategoryIcon({ category, active }) {
  const Icon = Icons[category.icon] || Icons.Store;
  return (
    <Link
      to={`/kategori/${category.slug}`}
      data-testid={`category-${category.slug}`}
      className={`press flex flex-col items-center gap-2 p-3 rounded-2xl border transition-colors duration-200 ${
        active ? "bg-primary text-primary-foreground border-primary" : "bg-card border-border hover:border-primary/40"
      }`}
    >
      <div className={`w-11 h-11 rounded-2xl grid place-items-center ${active ? "bg-primary-foreground/15" : "bg-primary/10 text-primary"}`}>
        <Icon className="w-5 h-5" />
      </div>
      <span className="text-xs font-medium text-center leading-tight line-clamp-2">{category.name}</span>
    </Link>
  );
}
